const disputeResolutionRouter = r => require.ensure([], () => r(require('@/page/disputeResolution/disputeResolutionRouter')), 'disputeResolutionRouter');

//  市纠纷化解台账
const cityDisputeResolution = r => require.ensure([], () => r(require('@/page/disputeResolution/disputeResolution/cityDisputeResolution')), 'cityDisputeResolution');
const disputeEnterInfo = r => require.ensure([], () => r(require('@/page/disputeResolution/dealWithAndDetails/disputeEnterInfo')), 'disputeEnterInfo');
const disputeEnterInfoDetail = r => require.ensure([], () => r(require('@/page/disputeResolution/dealWithAndDetails/disputeEnterInfoDetail')), 'disputeEnterInfoDetail');
const lookRepeat = r => require.ensure([], () => r(require('@/page/disputeResolution/dealWithAndDetails/lookRepeat')), 'lookRepeat');
const dataDashboardsList = r => require.ensure([], () => r(require('@/page/disputeResolution/dealWithAndDetails/dataDashboardsList')), 'dataDashboardsList');


// let sss = this.$store.state.conflictName
console.warn(this, 'this');

const disputeResolutionRouterFile = {
  path: '',
  name: '纠纷化解台账',
  component: disputeResolutionRouter,
  meta: {
    icon: 'expertInfo',
    right: [],
    isShowMenu: true,
    keepAlive: true,
  },
  children: [
    {
      path: '/cityDisputeResolution',
      component: cityDisputeResolution,
      name: '纠纷化解台账',
      meta: {
        right: ['市纠纷化解台账'],
        isShowMenu: true,
        // keepAlive:true,
      },
    },
    {
      path: '/disputeEnterInfo',
      component: disputeEnterInfo,
      name: '纠纷信息详情',
      meta: {
        right: ['录入'],
        name: '纠纷信息详情',
        // isShowMenu: true,
         keepAlive:false,
      },
      // name: meta.name,
    },
    {
      path: '/disputeEnterInfo1',
      component: disputeEnterInfo,
      name: '录入纠纷信息',
      meta: {
        right: ['录入'],
        name: '录入纠纷信息',
        // isShowMenu: true,
         keepAlive:false,
      },
      // name: meta.name,

    },
    {
      path: '/disputeEnterInfoDetail',
      component: disputeEnterInfoDetail,
      name: '纠纷信息详情',
      meta: {
        right: ['录入'],
        name: '纠纷信息详情',
        // isShowMenu: true,
         keepAlive:false,
      },
      // name: meta.name,

    },
    {
      path: '/lookRepeat',
      component: lookRepeat,
      name: '重复信息查看',
      meta: {
        right: ['重复问题分类信息查看'],
        name: '重复问题分类信息查看'
        // isShowMenu: true,
        // keepAlive:true,
      },
    },
    {
      path: '/contradictSourceList',
      component: dataDashboardsList,
      name: '矛盾纠纷来源',
      meta: {
        right: ['矛盾纠纷来源'],
        name: '矛盾纠纷来源'
      },
    },
    {
      path: '/contradictTrendList',
      component: dataDashboardsList,
      name: '矛盾纠纷列表',
      meta: {
        right: ['矛盾纠纷列表'],
        name: '矛盾纠纷列表'
      },
    },
    {
      path: '/duplicateAccessList',
      component: dataDashboardsList,
      name: '重复访统计',
      meta: {
        right: ['重复访统计'],
        name: '重复访统计'
      },
    },
  ]
};
export default disputeResolutionRouterFile;